// Simple posts endpoints for RTK Query
export const postsEndpoints = (builder) => ({
  // Get a list of posts
  getPosts: builder.query({
    query: () => "https://jsonplaceholder.typicode.com/posts?_limit=10",
  }),

  // Get a single post by ID
  getPost: builder.query({
    query: (postId) => `https://jsonplaceholder.typicode.com/posts/${postId}`,
  }),
});
